export default __webpack_public_path__ + "fonts/ionicons.6e86542f1ec8c5edf0803780166dcb13.woff2";